module.exports = __webpack_public_path__ + "img/destination_selous_ln2.5c04676c.jpg";